import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class FilterService {

    constructor(
    ) {}

    // Add filter with his value in the main query
    public setFilterInQuery(field: string, value: string|string[], query: string, valueContainSpaces?: boolean, strict?: boolean): string {
        // If query already contain this filter, remove it first
        if (field === 'is') {
            query = this.removeFilterFromQuery({field, filter: value as string}, query);

        } else {
            query = this.removeFilterFromQuery({field}, query);
        }

        let includeFuzzyOperator = true;

        if (field === 'is' || typeof value === 'boolean') {
            // No conversion for boolean values
            includeFuzzyOperator = false;
        } else if (Array.isArray(value)) {
            // Case where value is of type: [USR-00000, USR-00000, USR-00000]
            // Expected result: (USR-00000|USR-00000|USR-00000)

            if (!value.length) {
                return query;
            }
            value = '(' + _.join(value, '|') + ')';
            includeFuzzyOperator = false;

        } else if (valueContainSpaces) {
            // Case where value is of type: this is my request|this is another request
            // Expected result: ("this is my request"|"this is another request")

            let splittedValues = [];
            if (value.includes('|')) {
                splittedValues = value.split('|');
            }

            if (splittedValues.length > 1) {
                value = '(' + this.formatValuesWithQuotes(splittedValues) + ')';
                includeFuzzyOperator = false;
            } else {
                value = '"' + value + '"';
            }
        } else {
            // Case where value is of type: request1 request2 request3
            // Expected result: (request1 request2 request3)

            if (value.split(' ').length > 1 || value.split('|').length > 1) {
                value = '(' + value + ')';
                includeFuzzyOperator = false;
            }
        }
        return query + ' ' + field + ':' + (includeFuzzyOperator && !strict ? '~' : '') + value;
    }

    public removeFilterFromQuery({field, filter}: {field: string; filter?: string}, query: string): string {
        if (!query || !query.includes(field)) {
            return query;
        }

        const matchZeroOrFilter = filter || '.*?';
        const matchOneOrFilter = filter || '[^ ]+';

        return query.replace(
            // eslint-disable-next-line max-len
            new RegExp(field + `:\\(${matchZeroOrFilter}\\)|` + field + `:(~"${matchZeroOrFilter}"|"${matchZeroOrFilter}"|${matchOneOrFilter})`)
            , '');

    }

    public formatValuesWithQuotes(values: string[]): string {
        let result = '';
        for (const value of values) {
            if (result !== '') {
                result += '|';
            }
            result += '"' + value + '"';
        }
        return result;
    }
}
